import { Info } from 'lucide-react'

import { formatTimestamp, formatTime } from '@helpers/format'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import Spinner from '@components/Spinner'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

const ImpersonationSessionsList = ({ impersonationSessions, isLoading }) => {
  if (isLoading) return <Spinner />;

  return (
    <Card className='w-auto mb-5'>
      <CardHeader>
        <CardTitle className='text-lg'>Impersonation Sessions</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <Choose>
          <When condition={!impersonationSessions || impersonationSessions.length === 0}>
            <p className='text-gray-500 dark:text-gray-400'>Nothing has happened yet.</p>
          </When>
          <Otherwise>
            <For each='impersonationSession' of={[...impersonationSessions].reverse()}>
              <div key={impersonationSession.id} className='mb-6'>
                <h4 className='text-lg font-semibold leading-7 text-gray-900 dark:text-gray-100 flex gap-3 items-center mb-1'>
                  <div>
                    {impersonationSession.admin.firstName} {impersonationSession.admin.lastName}
                  </div>
                  <div className='text-sm text-gray-500 dark:text-gray-400 font-normal'>
                    {formatTime(impersonationSession.startedAt)} to {impersonationSession.finishedAt ? formatTimestamp(impersonationSession.finishedAt) : 'Now'}
                  </div>
                </h4>
                <Choose>
                  <When condition={impersonationSession.adminAuditsDuringPeriod.length > 0}>
                    <ul>
                      <For each='audit' of={impersonationSession.adminAuditsDuringPeriod}>
                        <li key={audit.id} className='mb-1'>
                          <div className='flex gap-2 items-center'>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Info id={`audit-${audit.id}`} className="inline-block mr-1 w-5 h-5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 cursor-help" />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <pre>
                                    {JSON.stringify(audit.auditedChanges, null, 2)}
                                  </pre>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                            <span className='text-gray-500 dark:text-gray-400'>
                              {formatTime(audit.createdAt)}
                            </span>
                            <span className="text-gray-900 dark:text-gray-100">
                              {audit.action} {audit.auditableType}#{audit.auditableId}
                            </span>
                          </div>
                        </li>
                      </For>
                    </ul>
                  </When>
                  <Otherwise>
                    <p className='text-gray-500 dark:text-gray-400'>Nothing happened.</p>
                  </Otherwise>
                </Choose>
              </div>
            </For>
          </Otherwise>
        </Choose>
      </CardContent>
    </Card>
  );
}

export default ImpersonationSessionsList; 
